import { dataLayerPush } from '@ertelecom/ui-react/components/helpers';

export const dataLayerForCPA = data => {
    if (data.request_id) {
        dataLayerPush({
            'event': 'trackTrans',
            'ecommerce': {
                'purchase': {
                    'actionField': {
                        'id': data.request_id
                    }
                }
            }
        });
    }
};
